<h6 class="border-bottom border-gray pb-2 mb-0">Blocked accounts</h6>
<ng-container *ngIf="users !== undefined">
  <ng-container *ngFor="let user of users">
    <div class="media pt-2">
      <div class="d-flex justify-content-between align-items-center w-100">
        <small><a class="font-weight-bold" [routerLink]="getUserEditLink(user.id)">{{user.username}}</a><br/>{{user.email}}</small>
        <small class="w-100 text-center">{{getTimeleft(user.blockedtimeexpiration)}}</small>
        <button class="btn btn-sm btn-success" (click)="unblock(user.id)">Unblock</button>
      </div>
    </div>
  </ng-container>
  <div *ngIf="users.length === 0" class="media pt-3">
    <div class="d-flex justify-content-center align-items-center w-100">
      <i class="fas fa-check-circle text-success px-1 mt-1"></i>
      <small>
        No user accounts blocked
      </small>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="users === undefined">
  <app-spinner></app-spinner>
</ng-container>
